import * as React from 'react';

import { OutputMapperEditorPanel } from '../../../customer/components/OutputMapper/index.ts';
import { LIST_OF_SERVICES_OUTPUT_MAPPER_KEY } from '../constants.ts';

interface Props {
    channelId?: string;
}

/**
 * List of Services output mapper. The shared editor panel now owns the output settings (output type,
 * iteration, default mapping source), the per-iteration editor view, the table preview, and the
 * change-confirmation dialog — so this is a thin binding to the `list_of_services` owner. The former
 * bespoke output-level selector is replaced by the shared `Article suggestions` iteration option.
 */
const ListOfServicesOutputMapperPanel = ({ channelId }: Props): React.ReactElement => {
    return (
        <div className="flex h-full min-h-0 flex-col">
            <OutputMapperEditorPanel outputMapperKey={LIST_OF_SERVICES_OUTPUT_MAPPER_KEY} ownerId={channelId} />
        </div>
    );
};

export default ListOfServicesOutputMapperPanel;
